import { c as _c } from "react/compiler-runtime";
import { ReactElement, ReactNode } from 'react';
import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';
import ImageComponent from '@spa/components/image-component/image.component';
import type { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import TooltipFixedTriggerComponent from '../../tooltips/tooltip-fixed-trigger/tooltip-fixed-trigger.component';
import classNames from 'clsx';
import styles from './product-delivery-method.component.module.scss';
import updateCsrSession from '@spa/lib/auth/updateCsrSession';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface ProductDeliveryMethodProps {
  readonly customOrderTypeToRender: CustomOrderType;
  readonly customOrderTypeAllowed: boolean | null;
  readonly isSelected: boolean;
  readonly onSelect: (customOrderType: CustomOrderType) => void;
  readonly title: string;
  readonly children: ReactNode;
}
interface DeliveryTypeConfig {
  readonly icon: {
    src: string;
    alt: string;
  };
  readonly testId: string;
}
const deliveryTypeConfig: Record<CustomOrderType, DeliveryTypeConfig> = {
  [CustomOrderType.HOME_DELIVERY]: {
    icon: {
      src: '/assets/icons/local-shipping.svg',
      alt: 'local shipping icon'
    },
    testId: 'pdp-homeDelivery-button'
  },
  [CustomOrderType.COLLECT_AT_STORE]: {
    icon: {
      src: '/assets/icons/storefront.svg',
      alt: 'storefront icon'
    },
    testId: 'pdp-collectAtStore-button'
  }
};
export const ProductDeliveryMethod = properties => {
  const $ = _c(46);
  const {
    customOrderTypeToRender,
    customOrderTypeAllowed,
    isSelected,
    onSelect,
    title,
    children
  } = properties;
  const {
    formatMessage
  } = useNamespacedIntl("product-info");
  const deliveryInfoKey = `deliveryLegalInfo.${customOrderTypeToRender}`;
  let t0;
  if ($[0] !== customOrderTypeAllowed || $[1] !== customOrderTypeToRender || $[2] !== onSelect) {
    t0 = () => {
      if (customOrderTypeAllowed) {
        updateCsrSession({
          latestSelectedDeliveryMethod: customOrderTypeToRender
        });
        onSelect(customOrderTypeToRender);
      }
    };
    $[0] = customOrderTypeAllowed;
    $[1] = customOrderTypeToRender;
    $[2] = onSelect;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleDeliveryTypeSelection = t0;
  let t1;
  if ($[4] !== customOrderTypeAllowed || $[5] !== handleDeliveryTypeSelection) {
    t1 = event => {
      if (customOrderTypeAllowed && (event.key === "Enter" || event.key === " ")) {
        event.preventDefault();
        handleDeliveryTypeSelection();
      }
    };
    $[4] = customOrderTypeAllowed;
    $[5] = handleDeliveryTypeSelection;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleDeliveryTypeSelectionByKey = t1;
  const {
    icon,
    testId
  } = deliveryTypeConfig[customOrderTypeToRender];
  const t2 = customOrderTypeAllowed ? 0 : -1;
  const t3 = !customOrderTypeAllowed;
  const t4 = !customOrderTypeAllowed;
  let t5;
  if ($[7] !== isSelected || $[8] !== t4) {
    t5 = classNames(styles["product-delivery-method"], {
      [styles["product-delivery-method--selected"]]: isSelected,
      [styles["product-delivery-method--disabled"]]: t4
    });
    $[7] = isSelected;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== icon.alt || $[11] !== icon.src) {
    t6 = <ImageComponent src={icon.src} height={32} width={32} alt={icon.alt} />;
    $[10] = icon.alt;
    $[11] = icon.src;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== title) {
    t7 = <span>{title}</span>;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className={styles["product-delivery-method__title"]}>{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = !customOrderTypeAllowed;
  let t10;
  if ($[18] !== t9) {
    t10 = classNames(styles["product-delivery-method__tooltip"], {
      [styles["product-delivery-method__tooltip--disabled"]]: t9
    });
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== deliveryInfoKey || $[21] !== formatMessage) {
    t11 = formatMessage(deliveryInfoKey);
    $[20] = deliveryInfoKey;
    $[21] = formatMessage;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== deliveryInfoKey || $[24] !== formatMessage) {
    t12 = formatMessage(deliveryInfoKey);
    $[23] = deliveryInfoKey;
    $[24] = formatMessage;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <div dangerouslySetInnerHTML={{
      __html: t12
    }} />;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t13) {
    t14 = <TooltipFixedTriggerComponent alt={t11}>{t13}</TooltipFixedTriggerComponent>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t14) {
    t15 = <div className={t10}>{t14}</div>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== children || $[35] !== handleDeliveryTypeSelection || $[36] !== handleDeliveryTypeSelectionByKey || $[37] !== isSelected || $[38] !== t15 || $[39] !== t2 || $[40] !== t3 || $[41] !== t5 || $[42] !== t8 || $[43] !== testId || $[44] !== title) {
    t16 = <div title={title} data-testid={testId} role="button" tabIndex={t2} aria-disabled={t3} aria-pressed={isSelected} className={t5} onClick={handleDeliveryTypeSelection} onKeyDown={handleDeliveryTypeSelectionByKey}>{t8}{children}{t15}</div>;
    $[34] = children;
    $[35] = handleDeliveryTypeSelection;
    $[36] = handleDeliveryTypeSelectionByKey;
    $[37] = isSelected;
    $[38] = t15;
    $[39] = t2;
    $[40] = t3;
    $[41] = t5;
    $[42] = t8;
    $[43] = testId;
    $[44] = title;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};